import type { PurchasePayment } from '@coreledger/shared-types';
import { api } from './client';

// Vendor-side mirror of payments.ts — see purchase-payments.service.ts's own
// comment for why a real record here matters (Balance Sheet's Cash and the
// Cash Ledger only ever counted money received before this existed).
export const purchasePaymentsApi = {
  byPurchaseInvoice: (purchaseInvoiceId: string) =>
    api.get<PurchasePayment[]>(`/purchase-invoices/${purchaseInvoiceId}/payments`),
  create: (data: Partial<PurchasePayment>) =>
    api.post<PurchasePayment>(`/purchase-invoices/${data.purchaseInvoiceId}/payments`, data),
  delete: (purchaseInvoiceId: string, id: string) =>
    api.delete<{ success: boolean }>(`/purchase-invoices/${purchaseInvoiceId}/payments/${id}`),
};
